/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var values = require("object-values");
var prop = require("prop");

module.exports = new Model({
	name: "availablemachines",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_availability: null,
	_machines: null,
	_online: true,

	recalculate: recalculate
});

function init() {
	this._availability = {};
	this._machines = {};
	this.push([]);
}

function uninit() {
	this._availability = null;
	this._machines = null;
}

function listeners() {
	return {
		"availability:updated": handle_availability_update,
		"groupmachines:updated": handle_group_machines_update,
		"machinetracker:updated": handleMachineTrackerUpdated,
		"online:updated": handleOnlineUpdate,
	};
}

function handleMachineTrackerUpdated(data) {
	var new_serial = data.serial;
	this._serial = new_serial;
	this.recalculate();
}

function handle_availability_update(availability) {
	this._availability = availability;
	this.recalculate();
}

function handle_group_machines_update(machines) {
	this._machines = machines;
	var machineUsers = values(machines).map(prop("who"));
	this.emit("availability:trigger:add", {
		lean: true,
		who: machineUsers
	});
	this.recalculate();
}

function recalculate() {
	var machines = this._machines;
	var available = this._availability;
	var machineSerials = Object.keys(machines);
	var ownSerial = this._serial;

	if (!machineSerials.length) {
		if (ownSerial)
			this.push([this._serial]);
		return;
	}

	var availableMachines = machineSerials.reduce(function (list, id) {
		var machine = machines[id];
		var user = machine.who;
		var serial = machine.serial;
		if (available[user])
			return list.concat(serial);
		return list;
	}, []);

	if (this._online && ownSerial && machineSerials.indexOf(ownSerial) === -1)
		availableMachines.push(this._serial);

	this.push(availableMachines);
}

function handleOnlineUpdate(online) {
	this._online = online;
}
